import { render } from "./VtoHotswapSave.vue?vue&type=template&id=17352fa6"
import script from "./VtoHotswapSave.vue?vue&type=script&lang=js"
export * from "./VtoHotswapSave.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__